import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = [
  ...restApiStates(['goods'], 'good', true, true, true),
  ...restApiStates(['goods', 'upload-image'], 'goodsUploadImage'),
  ...restApiStates(['goods', 'remove-image'], 'goodsImage', false, false),
];

const instantStates = [];
const storage = {};
const listValues = ['goods'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
